import { render, staticRenderFns } from "./SpecialCompareValue.vue?vue&type=template&id=68a1a127&scoped=true&"
import script from "./SpecialCompareValue.vue?vue&type=script&lang=js&"
export * from "./SpecialCompareValue.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCompareValue.vue?vue&type=style&index=0&id=68a1a127&lang=scss&scoped=true&"
import style1 from "./SpecialCompareValue.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1a127",
  null
  
)

export default component.exports